import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
};

export const isValidCode = code => !!STATES[code];
export const getStateValue = code => isValidCode(code) ? `${code} - ${STATES[code]}` : null;

const StateSelect = ({ className, includeBlank, ...props }) => (
  <select className={classNames(className, { 'text-muted': !props.value })} {...props}>
    {includeBlank !== false && (
      <option className="d-none" value="">
        {typeof includeBlank === 'string' ? includeBlank : ''}
      </option>
    )}
    {Object.keys(STATES).map(code => (
      <option key={code} value={code}>
        {getStateValue(code)}
      </option>
    ))}
  </select>
);

StateSelect.propTypes = {
  className: PropTypes.string,
  includeBlank: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  value: PropTypes.any
};

export default StateSelect;
